import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import shortid from "shortid";
import { withCookies } from "react-cookie";
import { connect } from "react-redux";
import { openAPI } from "../../config";
import qString from "query-string";
import * as actionTypes from "../../store/actions/actionTypes";
import CanonicalPagination from "../Common/CanonicalPagination";

const PagiantionPremium = props => {
  const { cookies } = props;
  const [pagination, setPagination] = useState(1);
  const [currentView, setCurrentView] = useState(15);
  const [totalResultCount, setResultCount] = useState(0);

  const URLRegexPatternALL = new RegExp("/all$");

  useEffect(() => {
    let isSubscribed = true;

    if (props.match.path === "/vendor/:id/case-studies" && isSubscribed) {
      setResultCount(props.vendorCaseStudies.total_reviews_count);
    }
    if (props.match.path === "/vendor/:id/testimonials" && isSubscribed) {
      setResultCount(props.vendorTestimonials.total_reviews_count);
    }
    if (props.match.path === "/vendor/:id/testimonials/all" && isSubscribed) {
      setResultCount(props.vendorTestimonials.total_reviews_count);
      if (currentView !== "all") {
        //props.updateState({ itemOnPage: 'all', paginationOn: 1 });
        props.setItemOnPage("all");
        props.setPaginationOn(1);
        setPagination(1);
        setCurrentView("all");
      }
    }
    if (props.match.path === "/vendor/:id/customer-videos" && isSubscribed) {
      setResultCount(props.vendorVideos.total_reviews_count);
    }
    return () => (isSubscribed = false);
  });

  //removed API for duplicate API call
  useEffect(() => {
    if (props.location.search.includes("NaN")) {
      props.history.push(`${props.location.pathname}`);
    } else {
      const qObject = qString.parse(props.location.search);
      if (props.location.search.includes("p=")) {
        props.toggleLoader();
        if (qObject.p.includes("NaN")) {
          props.setPaginationOn(1);
          setPagination(1);
          //getDataByPageNumber(1);
        } else {
          props.setPaginationOn(Number(qObject.p));
          setPagination(Number(qObject.p));
          //getDataByPageNumber(Number(qObject.p));
        }
      }
    }
  }, [props.location.search]);

  const composePages = (pageArray, paginationOn, vendorType) => {
    const showPages = pageArray.slice(paginationOn - 1, paginationOn + 2);
    return showPages.map((data, index) => (
      <li
        key={shortid.generate()}
        onClick={e => {
          e.preventDefault();
          props.toggleLoader();
          resetReviews();
          //props.updateReview(URL, props.itemOnPage, data.page);
          getDataByPageNumber(data.page);
          //props.updateState({ paginationOn: data.page });
          props.setPaginationOn(data.page);
          setPagination(data.page);
          setCurrentView(props.itemOnPage);
          props.history.push(getURLToPush(data.page));
        }}
        className={
          props?.paginationInfo?.current_page === data.page ? "active" : null
        }
      >
        {!!vendorType && vendorType.toLowerCase() === "premium" ? (
          <a
            href={
              data.page !== 1
                ? `${props.location.pathname}?p=${data.page}`
                : props.location.pathname
            }
          >
            {data.page}
          </a>
        ) : (
          <a
            href={
              data.page !== 1
                ? `${props.location.pathname}?p=${data.page}`
                : props.location.pathname
            }
            rel={data.page !== 1 ? "nofollow" : ""}
          >
            {data.page}
          </a>
        )}
      </li>
    ));
  };

  const getDataByPageNumber = pageNo => {
    let apiCriteriaToFetch = `${process.env.REACT_APP_API_URL}${props.location.pathname}${props.location.search}`;
    if (!!props.location.search) {
      apiCriteriaToFetch = `${apiCriteriaToFetch}&view=${props.itemOnPage}`;
      if (props.location.search.includes("p=")) {
        apiCriteriaToFetch = apiCriteriaToFetch.replace(
          /p=(\d+)?/,
          `p=${pageNo}`
        );
      } else {
        apiCriteriaToFetch = `${apiCriteriaToFetch}&p=${pageNo}`;
      }
    } else {
      apiCriteriaToFetch = `${apiCriteriaToFetch}?p=${pageNo}&view=${props.itemOnPage}`;
    }
    openAPI
      .get(`${apiCriteriaToFetch}`, {
        withCredentials: true,
      })
      .then(response => {
        props.toggleLoader();
        const splittedPath = props.match.url.split("/");
        let onTab = "";
        if (props.location.pathname.includes("/all")) {
          onTab = splittedPath[splittedPath.length - 2];
        } else {
          onTab = splittedPath[splittedPath.length - 1];
        }
        switch (onTab) {
          case "testimonials":
            props.updateVendorTestimonialsData(response.data);
            return null;
          case "case-studies":
            props.updateVendorCaseStudiesData(response.data);
            return null;
          case "customer-videos":
            props.updateVendorVideosData(response.data);
            return null;
          default:
            break;
        }
      });
  };

  const resetReviews = () => {
    const location = props.location.pathname.split("/");
    let onTab = "";
    if (props.location.pathname.includes("/all")) {
      onTab = location[location.length - 2];
    } else {
      onTab = location[location.length - 1];
    }
    if (onTab === "testimonials") {
      props.resetTestimonialReview();
    } else if (onTab === "case-studies") {
      props.resetCaseStudiesReview();
    } else if (onTab === "customer-videos") {
      props.resetVideosReview();
    } else {
      //
    }
  };

  const getURLToPush = pageNo => {
    if (pageNo === 0) {
      return props.location.pathname;
    } else if (!isNaN(pageNo)) {
      let tempUrl = `${props.location.pathname}${props.location.search}`;

      if (!!props.location.search) {
        if (tempUrl.includes("p=")) {
          if (pageNo === 1) {
            tempUrl = tempUrl.replace(/&p=(\d+)?/, "");
            tempUrl = tempUrl.replace(/p=(\d+)?/, "");
          } else {
            tempUrl = tempUrl.replace(/p=(\d+)?/, `p=${pageNo}`);
          }
        } else {
          tempUrl = `${tempUrl}&p=${pageNo}`;
        }
        return tempUrl;
      } else {
        return `${tempUrl}?p=${pageNo}`;
      }
    } else {
      return props.location.pathname.replace(/\/$/, "");
    }
    //props.history.push(tempUrl);
  };

  return (
    <div className="pagination">
      {totalResultCount > 15 ? (
        <React.Fragment>
          <div
            className={
              props?.paginationInfo?.current_page !== 1
                ? "arrow prev"
                : "arrow prev disabled"
            }
          >
            <a
              href={getURLToPush(props?.paginationInfo?.current_page - 1)}
              onClick={e => {
                e.preventDefault();
                if (props?.paginationInfo?.current_page !== 1) {
                  props.toggleLoader();
                  resetReviews();
                  props.setPaginationOn(
                    props?.paginationInfo?.current_page - 1
                  );
                  setCurrentView(props.itemOnPage);
                  setPagination(props?.paginationInfo?.current_page - 1);
                  getDataByPageNumber(props?.paginationInfo?.current_page - 1);
                  props.history.push(
                    getURLToPush(props?.paginationInfo?.current_page - 1)
                  );
                } else {
                  alert("You are on first page of result!");
                }
              }}
            ></a>
          </div>
          <div className="pagination_block">
            <ul>
              {composePages(
                props?.pageData,
                props?.paginationInfo?.current_page,
                props?.vendorCommon?.vendor_type
              )}
            </ul>
          </div>
          <div
            className={
              props?.paginationInfo?.current_page <
              props.paginationInfo.num_pages
                ? "arrow next"
                : "arrow next disabled"
            }
          >
            <a
              href={
                props?.paginationOn < props?.paginationInfo?.num_pages
                  ? getURLToPush(props?.paginationInfo?.current_page + 1)
                  : null
              }
              onClick={e => {
                e.preventDefault();
                if (
                  props?.paginationInfo?.current_page <
                  props.paginationInfo.num_pages
                ) {
                  props.toggleLoader();
                  resetReviews();
                  props.setPaginationOn(
                    props?.paginationInfo?.current_page + 1
                  );
                  setPagination(props?.paginationInfo?.current_page + 1);
                  setCurrentView(props.itemOnPage);
                  getDataByPageNumber(props?.paginationInfo?.current_page + 1);
                  props.history.push(
                    getURLToPush(props?.paginationInfo?.current_page + 1)
                  );
                } else {
                  alert("You are on last page of result!");
                }
              }}
              rel={
                !!props?.vendorCommon?.vendor_type &&
                props?.vendorCommon?.vendor_type.toLowerCase() === "premium"
                  ? ""
                  : "nofollow"
              }
            ></a>
          </div>
          {props.match.path === "/vendor/:id/case-studies" &&
            props.vendorCaseStudies &&
            props.vendorCaseStudies.pagination &&
            props.vendorCaseStudies.pagination.num_pages && (
              <CanonicalPagination
                totalPages={props.vendorCaseStudies.pagination.num_pages}
                currentPage={pagination}
                viewing={currentView}
                filter={props.vendorCommon.vendorFilter}
                pagination={props.vendorCaseStudies.pagination}
              />
            )}

          {props.match.path === "/vendor/:id/testimonials" &&
            props.vendorTestimonials &&
            props.vendorTestimonials.pagination &&
            props.vendorTestimonials.pagination.num_pages && (
              <CanonicalPagination
                totalPages={props.vendorTestimonials.pagination.num_pages}
                currentPage={pagination}
                viewing={currentView}
                filter={props.vendorCommon.vendorFilter}
                pagination={props.vendorTestimonials.pagination}
              />
            )}

          {props.match.path === "/vendor/:id/customer-videos" &&
            props.vendorVideos &&
            props.vendorVideos.pagination &&
            props.vendorVideos.pagination.num_pages && (
              <CanonicalPagination
                totalPages={props.vendorVideos.pagination.num_pages}
                currentPage={pagination}
                viewing={currentView}
                filter={props.vendorCommon.vendorFilter}
                pagination={props.vendorVideos.pagination}
              />
            )}
        </React.Fragment>
      ) : null}
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    saveVendorTestimonialsData: data =>
      dispatch({
        type: actionTypes.SAVE_VENDOR_TESTIMONIAL_DATA,
        payload: data,
      }),
    updateVendorTestimonialsData: data =>
      dispatch({
        type: actionTypes.UPDATE_VENDOR_TESTIMONIAL_REVIEWS,
        payload: data,
      }),

    updateVendorVideosData: data =>
      dispatch({
        type: actionTypes.UPDATE_VENDOR_VIDEOS_REVIEWS,
        payload: data,
      }),
    updateVendorCaseStudiesData: data =>
      dispatch({
        type: actionTypes.UPDATE_VENDOR_CASESTUDIES_REVIEWS,
        payload: data,
      }),
    saveVendorCaseStudiesData: data =>
      dispatch({
        type: actionTypes.SAVE_VENDOR_CASESTUDIES_DATA,
        payload: data,
      }),

    saveVendorVideoData: data =>
      dispatch({ type: actionTypes.SAVE_VENDOR_VIDEOS_DATA, payload: data }),
    resetTestimonialReview: () =>
      dispatch({ type: actionTypes.RESET_VENDOR_TESTIMONIAL_REVIEWS }),
    resetCaseStudiesReview: () =>
      dispatch({ type: actionTypes.RESET_VENDOR_CASESTUDIES_REVIEWS }),
    resetVideosReview: () =>
      dispatch({ type: actionTypes.RESET_VENDOR_VIDEOS_REVIEWS }),
  };
};

const mapStateToProps = state => {
  return {
    vendorCommon: state.vendorCommon,
    vendorTestimonials: state.vendorTestimonials,
    vendorCaseStudies: state.vendorCaseStudies,
    vendorVideos: state.vendorVideos,
  };
};

const PaginationWithRouter = withRouter(withCookies(PagiantionPremium));

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaginationWithRouter);
